import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaTerminosEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaTerminosEntry>('pagina-terminos-condiciones');
const cache: CacheRef<PaginaTerminosEntry> = { valor: null };

export const resetCacheClienteTerminosCondiciones = (): void => {
  cache.valor = null;
};

export const terminosCondicionesResolver: ResolveFn<
  PaginaTerminosEntry | null
> = (): Observable<PaginaTerminosEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'terminos-condiciones',
    uidTipo: 'pagina',
    slug: 'paginaterminoscondiciones',
  });
